import '../components/tms/tenant-hierarchy/tenant-hierarchy.css';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { ContentHeader } from './ContentHeader';

export function SegmentWithHeader({
  header,
  onClose,
  children,
  ...props
}: PropsWithChildren<
  {
    header: string;
    onClose?: any;
  } & HTMLAttributes<HTMLDivElement>
>) {
  return (
    <div {...props} className={`ui segment ${props.className}`} style={{ margin: 0 }}>
      <ContentHeader>
        {header}{' '}
        {onClose && (
          <button className="compact ui icon button">
            <i className="close icon" onClick={() => onClose()}></i>
          </button>
        )}
      </ContentHeader>
      <div style={{ marginTop: '15px' }}>{children}</div>
    </div>
  );
}
